<template>
    <a v-if="isExternalLink || compatibilityMode"
       :href="link.url"
       :rel="link.rel"
       :class="classElement"
       :target="target">
        {{link.title}}
        <slot></slot>
    </a>
    <router-link v-else
                 :class="classElement"
                 :to="pageTo">
        {{link.title}}
        <slot></slot>
    </router-link>
</template>

<script>

    import EventBusMixin from '../utils/mixinEventBus'

    export default {
        name: "LinkElement",
        mixins: [EventBusMixin],
        props: {
            link: {
                type: Object,
                required: true,
            },
            defaultClass: {
                type: String,
                default: "link",
            }
        },
        data() {
            return {
                target: '_blank'
            }
        },
        computed: {
            isExternalLink() {
                if (this.link.url && this.link.url.indexOf("#") > -1 || this.link.url.indexOf("tel:") > -1 ) {
                    this.target = "_self";
                }

                return this.link && (this.link.is_external || this.link.target) || false;
            },
            pageTo() {
                const replace = new RegExp(`^http[s]*://${location.host}`, "i");
                return this.link && this.link.url && this.link.url.replace(replace, '') || '';
            },
            classElement() {
                let classes = this.link && this.link.class || '';
                return `${classes} ${this.defaultClass}`;
            }
        },
        methods: {
            getIsExternalLink() {
                return this.isExternalLink();
            },
            emit() {
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    .theme-button {
        cursor: pointer;
        color: $theme-brown;
        display: inline-block;
        font-size: 14px;
        font-weight: 600;
        margin-right: 25px;
        position: relative;
        transition: all 0.3s ease-in-out 0s;
        z-index: 1;

        &:after {
            content: '+';
            font-size: 22px;
            font-weight: normal;
            position: absolute;
            right: -20px;
            top: 0;
        }

        &:hover, &:focus {
            color: $theme-green;
        }
    }

    .theme-button-border {
        background: transparent;
        border: 3px solid $theme-green;
        cursor: pointer;
        color: $theme-green;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        line-height: 49px;
        min-width: 160px;
        padding: 0 25px;
        text-align: center;
        text-decoration: none!important;
        transition: all 0.3s ease-in-out 0s;

        &:hover, &:focus {
            background: $theme-green;
            color: $theme-white;
        }
    }

    .square-button {
        background: $theme-copy-color;
        color: $theme-white;
        display: inline-block;
        height: 55px;
        line-height: 55px;
        width: 55px;
        text-align: center;
        font-size: 20px;
    }

</style>